export default __webpack_public_path__ + "static/media/session.1eecca5c.png";